import React from "react";
import StudioImages from "./TripImages";

const App = () => {
  return (
    <div>
      <h1>Trip Out West</h1>
      <StudioImages />
    </div>
  );
};

export default App;
